import { classnames } from '@aibees/shared/utils';
import { Switch } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SortableActiveProps as Props } from './types';

export const SortableActive = memo(
  ({ className, item, handleToggleActive, isLoading }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('SortableActive', className)}
        sx={SX.root}
      >
        <Switch
          checked={item.value.active}
          onChange={handleToggleActive}
          disabled={isLoading}
        />
      </Styled.Wrapper>
    );
  }
);

SortableActive.displayName = 'SortableActive';
